"use client";

import Script from "next/script";

import { env } from "@/env.mjs";

// ----------------------------------------------------------------------------
// Google Ads tag (gtag.js) for conversion tracking + remarketing.
//
// Loaded on `afterInteractive` (not deferred behind first interaction like
// the Clarity/analytics trackers) because Ads conversion tracking must run
// reliably on the landing pageview to capture the `gclid` and link clicks to
// conversions — the whole point of the paid campaigns.
//
// Consent: this tag does NOT define its own consent defaults. The
// `gtag-consent-default` script in GoogleTagManagerScript.tsx already runs
// `beforeInteractive` and sets ad_storage / ad_user_data / ad_personalization
// to "denied" by default, then the Mandatly cookie banner flips them via
// `__cbConsentUpdate` on Accept. Because gtag() + dataLayer are shared
// globals, this Ads tag automatically inherits that consent state — modeled
// conversions when denied, direct measurement when granted (Consent Mode v2).
//
// The AW id is a public client-side identifier (not a secret), so it is
// hardcoded here the same way Clarity/Metricool/etc. hardcode theirs.
// ----------------------------------------------------------------------------

const GOOGLE_ADS_ID = "AW-18293128688";

const GoogleAdsTagScript = () => {
  // Gate on the prod-features flag so the tag never fires from dev / UAT
  // and pollutes the Ads account with non-production traffic.
  if (!env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES) return null;

  // LEGACY 2026-07 - AW-18293128688 now loaded via GTM-PD5CTSH; kept for rollback
  //
  // GTM container GTM-PD5CTSH (published v29) now loads this same Google Ads
  // tag, so keeping the hardcoded copy double-loaded gtag.js and issued a
  // second `config` for the same AW id. GTM is now the ONLY Ads loading path.
  //
  // Safe to disable: window.dataLayer and window.gtag are initialised
  // independently by GoogleTagManagerScript.tsx in its `gtag-consent-default`
  // script at strategy="beforeInteractive", which already ran before this
  // component's "afterInteractive" ever did. The Consent Mode v2 defaults live
  // there too, so neither the globals nor consent depend on the block below.
  //
  // TO ROLL BACK: pause the Google Ads tag in GTM FIRST, then uncomment —
  // otherwise the tag double-loads again.
  //
  // return (
  //   <>
  //     <Script
  //       id="google-ads-gtag-lib"
  //       src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
  //       strategy="afterInteractive"
  //     />
  //     <Script id="google-ads-gtag-config" strategy="afterInteractive">
  //       {`
  //         window.dataLayer = window.dataLayer || [];
  //         function gtag(){dataLayer.push(arguments);}
  //         gtag('js', new Date());
  //         gtag('config', '${GOOGLE_ADS_ID}');
  //       `}
  //     </Script>
  //   </>
  // );

  return null;
};

export default GoogleAdsTagScript;
